import { render, staticRenderFns } from "./videoJs.vue?vue&type=template&id=2fee34e1&"
import script from "./videoJs.vue?vue&type=script&lang=js&"
export * from "./videoJs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports